import findIndex from 'lodash/findIndex';

export default (state = {}, action = {}) => {
  switch(action.type) {
    case 'FETCH_INVCS':
      if(action.payload.data.length>0){
        return {
          ...state,
          [action.payload.order_id]:{
            data: action.payload.data
          }
        }
      }
      else{
        return {
          ...state,
          [action.payload.order_id]:{
            data: []
          }
        }
      }
    case 'EDIT_INVC':
      const index = findIndex(state[action.payload.invc_order_id].data,
        { invc_id: action.payload.invc_id });
      if (index >= 0) {
        return {
          ...state,
          [action.payload.invc_order_id]:{
            ...state[action.payload.invc_order_id],
            data: [
              ...state[action.payload.invc_order_id].data.slice(0, index),
              action.payload,
              ...state[action.payload.invc_order_id].data.slice(index + 1)
            ]
          }
        }
      }
      return state;
    case 'CREATE_INVC':
      return {
        ...state,
        [action.payload.invc_order_id]:{
          ...state[action.payload.invc_order_id],
          data: [
            ...state[action.payload.invc_order_id].data,
            action.payload
          ]
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/invcs.js